import { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectIsPreinstall, selectPlanCharacteristics } from '@app/redux';

import { useShowUnleashedUsage } from '../hooks';
import { StoreProvider } from './context';
import { DailyUsageChart } from './presenters/DailyUsageChart';
import { UnleashedDailyUsageChart } from './presenters/DailyUsageChart/UnleashedDailyUsageChart';
import { TotalUsageChart } from './presenters/TotalUsageChart';

export const UsageHistory = (): JSX.Element | null => {
  const [showMonthly, setShowMonthly] = useState(true);
  const [selectedBillCycle, setSelectedBillCycle] = useState(0);
  const [showAlertMessage, setShowAlertMessage] = useState(false);

  const {
    characteristics: { hasUnlimitedUsageMeter },
  } = useSelector(selectPlanCharacteristics);

  const isPreInstall = useSelector(selectIsPreinstall);

  const shouldShowDonutChart = showMonthly && !hasUnlimitedUsageMeter && !isPreInstall;

  const shouldShowUnleashedUsage = useShowUnleashedUsage();

  if (shouldShowUnleashedUsage) {
    return <UnleashedDailyUsageChart />;
  }

  return (
    <StoreProvider
      value={{
        selectedBillCycle,
        showMonthly,
        showAlertMessage,
        setSelectedBillCycle,
        setShowMonthly,
        setShowAlertMessage,
      }}
    >
      {shouldShowDonutChart ? <TotalUsageChart /> : <DailyUsageChart />}
    </StoreProvider>
  );
};

export default UsageHistory;
